import { render, staticRenderFns } from "./PostOrganization.vue?vue&type=template&id=66446141&"
import script from "./PostOrganization.vue?vue&type=script&lang=js&"
export * from "./PostOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports